/* Cookie Box Builder – Monster Cookie */
if (!customElements.get('cookie-box-builder')) {
  customElements.define(
    'cookie-box-builder',
    class CookieBoxBuilder extends HTMLElement {
      connectedCallback() {
        const configEl = this.querySelector('[data-cookie-box-config]');
        if (!configEl) return;
        this.config = JSON.parse(configEl.textContent);
        this.boxes = this.config.boxes.sort((a, b) => a.size - b.size);
        if (!this.boxes.length) return;

        // Only flavors that are in stock in every box size are offered.
        this.flavors = this.config.flavors.filter((f) =>
          this.boxes.every((b) => b.variants[f.name] && b.variants[f.name].available)
        );
        this.flavorByName = Object.fromEntries(this.flavors.map((f) => [f.name, f]));

        const requested = parseInt(new URLSearchParams(window.location.search).get('box'), 10);
        this.box = this.boxes.find((b) => b.size === requested) || this.boxes[0];
        this.picks = []; // ordered list of flavor names, one entry per cookie

        this.els = {
          sizes: this.querySelector('[data-sizes]'),
          grid: this.querySelector('[data-grid]'),
          empty: this.querySelector('[data-empty]'),
          bar: this.querySelector('[data-bar]'),
          progressText: this.querySelector('[data-progress-text]'),
          progressHint: this.querySelector('[data-progress-hint]'),
          slots: this.querySelector('[data-slots]'),
          compare: this.querySelector('[data-compare]'),
          total: this.querySelector('[data-total]'),
          saving: this.querySelector('[data-saving]'),
          add: this.querySelector('[data-add]'),
          clear: this.querySelector('[data-clear]'),
          error: this.querySelector('[data-error]'),
          live: this.querySelector('[data-live]'),
        };

        this.renderSizes();
        this.renderGrid();
        this.els.add.addEventListener('click', () => this.addToCart());
        this.els.clear.addEventListener('click', () => {
          this.picks = [];
          this.update();
        });
        this.els.slots.addEventListener('click', (e) => {
          const slot = e.target.closest('[data-slot-index]');
          if (!slot) return;
          this.picks.splice(Number(slot.dataset.slotIndex), 1);
          this.update();
        });
        this.update();
      }

      formatMoney(cents) {
        const value = (cents / 100).toFixed(2);
        const withComma = value.replace('.', ',');
        return this.config.moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
          if (key === 'amount_with_comma_separator') return withComma;
          if (key === 'amount_no_decimals') return Math.round(cents / 100).toString();
          if (key === 'amount_no_decimals_with_comma_separator') return Math.round(cents / 100).toString();
          return value;
        });
      }

      count(name) {
        return this.picks.filter((p) => p === name).length;
      }

      maxFor(flavor) {
        // stock of the real cookie (shared by all box sizes); fall back to box size if unknown
        return flavor.stock > 0 ? flavor.stock : this.box.size;
      }

      renderSizes() {
        this.els.sizes.innerHTML = '';
        this.boxes.forEach((box) => {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'cbb__size';
          btn.dataset.size = box.size;
          btn.innerHTML = `${box.size}er Box${box.discount ? `<small>${box.discount}% sparen</small>` : ''}`;
          btn.addEventListener('click', () => this.selectBox(box));
          this.els.sizes.appendChild(btn);
        });
      }

      selectBox(box) {
        this.box = box;
        if (this.picks.length > box.size) this.picks = this.picks.slice(0, box.size);
        this.els.error.textContent = '';
        this.update();
      }

      renderGrid() {
        const grid = this.els.grid;
        grid.innerHTML = '';
        this.els.empty.hidden = this.flavors.length > 0;
        this.flavors.forEach((flavor) => {
          const li = document.createElement('li');
          li.className = 'cbb-card';
          li.dataset.flavor = flavor.name;
          li.innerHTML = `
            <div class="cbb-card__media">
              ${flavor.image ? `<img src="${flavor.image}" alt="" loading="lazy" width="600" height="600">` : ''}
            </div>
            <span class="cbb-card__badge" data-badge hidden></span>
            <div class="cbb-card__body">
              <p class="cbb-card__title"></p>
              <button type="button" class="cbb-card__fill" data-fill>Box damit auffüllen</button>
              <div class="cbb-card__row">
                <span class="cbb-card__price" data-price></span>
                <div class="cbb-stepper">
                  <button type="button" class="cbb-btn" data-minus hidden>&minus;</button>
                  <span class="cbb-stepper__qty" data-qty hidden></span>
                  <button type="button" class="cbb-btn" data-plus>+</button>
                </div>
              </div>
            </div>`;
          li.querySelector('.cbb-card__title').textContent = flavor.name;
          const img = li.querySelector('img');
          if (img) img.alt = flavor.alt;
          li.querySelector('[data-minus]').setAttribute('aria-label', `${flavor.name} entfernen`);
          li.querySelector('[data-plus]').setAttribute('aria-label', `${flavor.name} hinzufügen`);
          li.querySelector('[data-plus]').addEventListener('click', () => this.add(flavor.name, 1));
          li.querySelector('[data-minus]').addEventListener('click', () => this.remove(flavor.name));
          li.querySelector('[data-fill]').addEventListener('click', () =>
            this.add(flavor.name, this.box.size - this.picks.length)
          );
          grid.appendChild(li);
        });
      }

      add(name, amount) {
        const flavor = this.flavorByName[name];
        const room = this.box.size - this.picks.length;
        const stockRoom = this.maxFor(flavor) - this.count(name);
        const n = Math.min(amount, room, stockRoom);
        if (n <= 0) return;
        for (let i = 0; i < n; i++) this.picks.push(name);
        this.els.error.textContent = '';
        this.els.live.textContent = `${name} hinzugefügt. ${this.picks.length} von ${this.box.size} ausgewählt.`;
        this.update();
      }

      remove(name) {
        const idx = this.picks.lastIndexOf(name);
        if (idx === -1) return;
        this.picks.splice(idx, 1);
        this.els.live.textContent = `${name} entfernt. ${this.picks.length} von ${this.box.size} ausgewählt.`;
        this.update();
      }

      totals() {
        const original = this.picks.reduce((sum, name) => sum + this.box.variants[name].price, 0);
        const full = this.picks.length === this.box.size;
        const saving = full ? Math.round((original * this.box.discount) / 100) : 0;
        return { original, saving, final: original - saving, full };
      }

      update() {
        const { size, discount } = this.box;
        const filled = this.picks.length;
        const full = filled === size;

        this.els.sizes.querySelectorAll('.cbb__size').forEach((btn) => {
          btn.setAttribute('aria-pressed', String(Number(btn.dataset.size) === size));
        });

        this.els.grid.querySelectorAll('.cbb-card').forEach((card) => {
          const flavor = this.flavorByName[card.dataset.flavor];
          const qty = this.count(flavor.name);
          const canAdd = !full && qty < this.maxFor(flavor);
          card.classList.toggle('is-selected', qty > 0);
          card.querySelector('[data-price]').textContent = this.formatMoney(this.box.variants[flavor.name].price);
          card.querySelector('[data-qty]').textContent = qty;
          card.querySelector('[data-qty]').hidden = qty === 0;
          card.querySelector('[data-minus]').hidden = qty === 0;
          card.querySelector('[data-plus]').disabled = !canAdd;
          card.querySelector('[data-fill]').hidden = !canAdd || size - filled < 2;
          const badge = card.querySelector('[data-badge]');
          badge.hidden = qty === 0;
          badge.textContent = `${qty}×`;
        });

        this.els.slots.innerHTML = '';
        for (let i = 0; i < size; i++) {
          const name = this.picks[i];
          const slot = document.createElement(name ? 'button' : 'span');
          slot.className = `cbb__slot${name ? ' is-filled' : ''}`;
          if (name) {
            slot.type = 'button';
            slot.dataset.slotIndex = i;
            slot.title = `${name} entfernen`;
            const thumb = this.flavorByName[name].thumb;
            if (thumb) slot.innerHTML = `<img src="${thumb}" alt="">`;
          }
          this.els.slots.appendChild(slot);
        }

        const t = this.totals();
        this.els.progressText.textContent = `${filled} / ${size} Cookies`;
        this.els.progressHint.textContent = full
          ? 'Deine Box ist voll!'
          : `Noch ${size - filled} ${size - filled === 1 ? 'Cookie' : 'Cookies'} wählen`;
        this.els.total.textContent = this.formatMoney(t.final);
        this.els.compare.hidden = !t.saving;
        this.els.compare.textContent = this.formatMoney(t.original);
        this.els.saving.textContent = t.saving
          ? `Du sparst ${this.formatMoney(t.saving)} (${discount}%)`
          : discount
          ? `Volle Box = ${discount}% Rabatt`
          : '';
        this.els.add.disabled = !full;
        this.els.clear.hidden = filled === 0;
      }

      async addToCart() {
        if (this.picks.length !== this.box.size) return;
        const boxId = `${this.box.size}-${Date.now().toString(36)}${Math.random().toString(36).slice(2, 6)}`;
        const counts = {};
        this.picks.forEach((name) => (counts[name] = (counts[name] || 0) + 1));
        const items = Object.entries(counts).map(([name, quantity]) => ({
          id: this.box.variants[name].id,
          quantity,
          properties: { _cookie_box: boxId },
        }));

        this.els.add.setAttribute('aria-busy', 'true');
        this.els.error.textContent = '';
        try {
          const res = await fetch(this.config.cartAddUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items }),
          });
          const data = await res.json();
          if (!res.ok) {
            throw new Error(data.description || data.message || 'Die Box konnte nicht hinzugefügt werden.');
          }
          window.location.href = this.config.cartUrl;
        } catch (err) {
          this.els.error.textContent = err.message;
          this.els.add.removeAttribute('aria-busy');
        }
      }
    }
  );
}
